const CONSTANT = {
  CANVAS_WIDTH: 594.95996,
  CANVAS_HEIGHT: 841.91998,
  POST_IT_SIZE: 150,
  POST_IT_CLOSE_BOX_SIZE: 17,
  POST_IT_CLOSE_TEXT_SIZE: 10,
  POST_IT_PADDING: 5,
  POST_IT_BORDER: 1,
};

export default CONSTANT;
